import {v3} from "oc-threejs/short3";
import Scenes from "oc-threejs/Scenes";
import LengthRulerRepresentation from "oc-virtual3d/representations/LengthRulerRepresentation";
import simpleSizeFormatter from "oc-threejs/objects/rulers/simpleSizeFormatter";
import Maths3 from "oc-threejs/Maths3.js";
import Brett from "../object3d/Brett";
import Textures from "oc-threejs/Textures.js";


export default class Sketcher {

    undoCallbacks = [];

    constructor(data, schrank) {
        this.data = data;
        this.schrank = schrank;
    }

    containedInSketch(brett) {
        const product = brett.vsData.product;
        if (product == null) return false;

        if (['Rueckwand', 'Schubladenbox', 'Tuer'].indexOf(product.type) != -1) return false;

        if (!brett.vsData.inSketch) return false;

        return true;
    }

    createSketch() {
        STAGE.setOrthographicMode(true, {
            object: this.schrank.object3d,
            directionOfCamera: v3(0, 0, -1).applyQuaternion(this.schrank.quaternion),
            up: v3(0, 1, 0),
            border: 30,
            sphere: Scenes.unionBounds(APP.arrangement.schraenke.map(s=>s.object3d)).getBoundingSphere()
        });

        APP.arrangement.schraenke.forEach(schrank => {
            if (schrank !== this.schrank) {
                const box3 = schrank.box;
                const schrankGrauGroup = new THREE.Group();
                const schrankGrauBox = Scenes.box(box3.getSize(), new THREE.MeshBasicMaterial({
                    color: 0xa0a0a0,
                    transparent: true,
                    opacity: 0.2
                }));
                schrankGrauBox.position.copy(box3.getSize().multiplyScalar(0.5));
                schrankGrauGroup.add(schrankGrauBox);
                schrankGrauGroup.copyMatrix(schrank.matrix);
                this.schrankGrauBox = schrankGrauBox;
                STAGE.scene.add(schrankGrauGroup);
                schrank.object3d.visible = false;
                this.undoCallbacks.push(() => {
                    schrank.object3d.visible = true;
                    Scenes.remove(schrankGrauGroup);
                });
            }
        });

//        APP.model.raum.visible = false;
        STAGE.useComposer = false;
        this.modified = Scenes.filter(APP.model, object => object.visible)
        this.setVisibility(false);
        this.bretter = Scenes.filter(this.schrank.object3d, object => object instanceof Brett)
        STAGE.scene.updateMatrixWorld(true);

        this.bretter.forEach(brett => {
            if (!this.containedInSketch(brett)) return;
            const typeOf = brett => (brett.vsData.product == null) ? null : brett.vsData.product.type;
            const geo = new THREE.EdgesGeometry(brett.geometry);
            const mat = new THREE.LineBasicMaterial({color: 0x000000, linewidth: 1});
            const edge = new THREE.LineSegments(geo, mat);
            edge.copyMatrix(brett.matrixWorld);
            STAGE.scene.add(edge);
            this.undoCallbacks.push(() => Scenes.remove(edge));
        });

        this.createSchrankRulers();
        this.createElementRulers();
        const format = simpleSizeFormatter();
        const grauBoxSize = this.schrankGrauBox ? Scenes.boundingBox(this.schrankGrauBox).getSize() : v3();
        const x = this.schrank.position.x;
        const z = this.schrankGrauBox ? this.schrank.size.x - grauBoxSize.z : 0;
        this.text(`Gesamttiefe: ${format(this.schrank.sizeOuter.z)}`, x, -35, 'left', z);
        this.text(`Nutzbare Tiefe innen: ${format(this.schrank.elements[0].size.z)}`, x, -45, 'left', z);
    }

    createSchrankRulers() {
        const box = this.schrank.box;
        const xOffset = (this.schrank.size.x < 50) ?-10 : -20;
        this.ruler(box, "x", 0, xOffset);

        const slopings = this.schrank.slopings;
        if (slopings.isSloped(box)) {
            const y1 = slopings.yOfX(box.min.x, 0);
            const y2 = slopings.yOfX(box.max.x, 0);
            if (y1 < y2) {
                this.ruler(box, "y", 1, 10);
                this.ruler(box, "x", 1, 10, [box.max.x - this.schrank.sizeTop.x, null]);
                this.ruler(box, "y", 0, -10, [null, y1]);
            } else {
                this.ruler(box, "y", 0, -10);
                this.ruler(box, "x", 1, 10, [null, this.schrank.sizeTop.x]);
                this.ruler(box, "y", 1, 10, [null, y2]);
            }
        } else {
            this.ruler(box, "y", 1, 10);
        }

    }

    createElementRulers() {
        const xOffset = (this.schrank.size.x < 50) ? -7 : -20;
        this.schrank.elements.forEach(element => {
            this.ruler(element.box, "x", 0, xOffset);
            this.createFaecherRulers(element);
        })
    }

    createFaecherRulers(element) {
        element.faecher.forEach(fach => {
            //const sizeY = fach.getSize().y;
            this.ruler(fach, "y", 0.5, 0, undefined);
        })
    }

    text(msg, x, y, justify, schrankWidth = 0) {
        const textPlane = Textures.createTextSpriteOrPlane(msg, {
            orginalHeight: 8,
            color: "black",
            backgroundColor: "white",
            textAsSprite: false,
            depthTest: true,
            moveTextUpinHeightMultiplies: 0,
            textCanvasCallback: undefined,
            justify: justify,
        });
        textPlane.copyMatrix(this.schrank.object3d.matrixWorld);
        const size = new THREE.Box3().setFromObject(textPlane).getSize();
        if (justify == 'left') {
            x += size.x / 2;
            if (schrankWidth !== 0) {

            }
            //schrankWidth += schrankWidth !== 0 ? schrankWidth + (size.x / 2) : 0;
        }
        if (justify == 'right') {
            x -= size.x / 2;
            //schrankWidth += schrankWidth !== 0 ? schrankWidth + (size.x / 2) : 0;
        }
        textPlane.position.copy(v3(x, y, schrankWidth));

        STAGE.scene.add(textPlane);
        this.undoCallbacks.push(() => Scenes.remove(textPlane));
    }

    ruler(box, dim, anchor, offset, range) {
        const p1 = box.min.clone();
        const p2 = box.max.clone();

        const o = dim == "x" ? "y" : "x";

        const showLinesFrom = 30;
        let fontHeight = 8;

        if (box.getSize()[o] < (showLinesFrom + 20)) {
            fontHeight = 4;
        }

        p1.z = p2.z = 0;
        p1[o] = p2[o] = box.min[o] + anchor * (box.max[o] - box.min[o]) + offset;

        const q = dim == "x" ? Maths3.quaternion.zero : Maths3.quaternion.z90;

        if (range && range[0] != null) p1[dim] = range[0];
        if (range && range[1] != null) p2[dim] = range[1];

        const options = {
            point1: p1,
            point2: p2,
            normal: v3(0, 0, 1),
            offsets: [0, -(fontHeight/2), (fontHeight/2)],
            showLines: true,
            showLinesIfLengthGreaterThen: showLinesFrom,
            sizeFormatter: simpleSizeFormatter(),
            textQuaternion: q,
            textOffset: v3(),
            fontHeight: fontHeight,
            fontDepthTest: true,
            fontColor: "black",
            backgroundColor: null,
            negative: false,
            textAsSprite: false,
            onTap: null,
            moveTextUpinHeightMultiplies: 0,
            textCanvasCallback: undefined,
            createMeshMaterial: () => new THREE.LineBasicMaterial({color: 0x000000})
        };
        const ruler = new LengthRulerRepresentation(options);
        ruler.copyMatrix(this.schrank.object3d.matrixWorld);
        STAGE.scene.add(ruler);
        this.undoCallbacks.push(() => Scenes.remove(ruler));
    }

    restore() {
        this.undoCallbacks.forEach(x => x());
        STAGE.setOrthographicMode(false);
        STAGE.useComposer = true;
        this.setVisibility(true);
    }

    setVisibility(visible) {
        this.modified.forEach(object => object.visible = visible)
    }

}
